import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import styled from 'styled-components';

import { MoreCaseStudies } from '../../../../components'

import { meta } from '../../index.js'

export default class tnt extends Component {
	render () {
		return (
			<React.Fragment>
				<Helmet
					title={meta.title.replace('blueshyft', 'TNT')}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.url + meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.url + meta.image },
					]}
				/>
				
				<section className="case-study"> 

				    <div className="container">

				        <div className="title">

				            <a href="https://tnt.com.au" target="_blank"><img src="/images/new/logos/tnt.svg"/></a>
				            <h3>TNT: The People Network</h3>

				            <p>Every day, TNT go to great lengths to connect people and businesses all over the planet because they understand 
				            how important each and every parcel is to their customers. But while the customer is always right, the customer isn’t 
				            always home. TNT needed a solution to stop their door-to-door service becoming a door-to-depot service.</p>

				        </div>

				        <div className="block">

				            <h4>Identifying limitations, innovating solutions</h4>
				            <p>TNT recognised the need to offer their customers a more streamlined service to collect their parcel when they missed a home delivery. It wasn’t just customers who were in need of a solution; re-processing ‘not-at-home’ deliveries was driving up unnecessary operational overheads for TNT. blueshyft’s network of 1,500+ retailer locations enabled TNT to establish trusted local drop-off points where customers could collect and return their parcels at their own convenience.</p>

				        </div>

				        <div className="block">

				            <h4>Finding a new direction</h4>
				            <p>The challenge was to develop a platform that would provide TNT with all their requested features in a short time frame, including:</p>

				            <div className="features">

				                <div className="feature">
				                    <img src="/images/new/icons/cross-blue.svg"/>
				                    <p>Failed delivery collection points</p>
				                </div>
				                <div className="feature">
				                    <img src="/images/new/icons/arrow-blue.svg"/>
				                    <p>Direct delivery to designated outlets</p>
				                </div>
				                <div className="feature">
				                    <img src="/images/new/icons/returns-blue.svg"/>
				                    <p>Easy product returns</p>
				                </div>
				                <div className="feature">
				                    <img src="/images/new/icons/truck-blue.svg"/>
				                    <p>Parcel Tracking</p>
				                </div>
				                <div className="feature">
				                    <img src="/images/new/icons/cog-blue.svg"/>
				                    <p>Total API Integration</p>
				                </div>

				            </div>
				    
				        </div>

				        <div className="block">

				            <h4>Another successful delivery</h4>
				            <p>blueshyft worked with TNT to develop, test and roll out a nation-wide service that surpassed all expectations - TNT Local Exchange. This time, blueshyft were the ones delivering:</p>
				            <p>•  A national network of physical locations - with over 1,500+ storefronts, customers are sure to have one or more blueshyft pick-up & drop-off locations nearby, streamlining  the  deliveries process while  boosting customer convenience and satisfaction</p>
				            <p>•  Seamless digital processes - blueshyft’s platform  provides customers with a streamlined parcel check-out service</p>

				        </div>

				        <div className="highlight">

				            <p>Since the launch of TNT Local Exchange, the blueshyft platform has provided access to a quick and convenient network of parcel pick-up and drop-off locations. The platform has allowed TNT to reduce the number of failed and home re-deliveries considerably, with a remarkable reduction in overheads since launch. The platform has provided a simple solution for TNT’s modern-day customer - access to a quick and convenient network of parcel pick-up and drop-off locations, and no more door to depot!</p>
				    
				        </div>

				    </div>

				</section>

				<MoreCaseStudies cases={['lb', 'goget', 'news']} />

			</React.Fragment>
		);
	}
};


// WEBPACK FOOTER //
// ./client/scenes/Clients/scenes/tnt/index.js